// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__kaOL5","heading":"FAQ_heading__AmwbZ"};